import { compose, renderNothing, branch, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { change, arraySplice, formValueSelector } from 'redux-form';
import { find, findIndex, sortBy } from 'lodash';
import { t } from '../../../../modules/infra/i18n';
import { fetchBrandAndShopUsers, resetBrandAndShopUsers } from '../../users/actions';
import EditBrand from '../components/editBrand';
import { updateBrand, deleteBrand, fetchBrand } from '../actions';
import { getBrand } from '../reducers';
import withNotifications from '../../../common/withNotifications';
import { getShops } from '../../shops/reducers';
import confirmModal from '../../../common/confirmModal';
import delayRender from '../../../common/hoc/delayRender';

const selector = formValueSelector('brandForm');
const mapStateToProps = (state, props) => ({
  brand: getBrand(state, props.params.id),
  brandShops: sortBy(selector(state, 'brandShops'), ['shopOrder']),
  shops: getShops(state),
});

const updateOrder = sortedArray => dispatch => dispatch(change('brandForm', 'brandShops', sortedArray));
const updateShopSelection = (updated, current, brandShops, shops) => (dispatch) => {
  const updatedShop = find(shops, shop => shop.id === updated);
  const index = findIndex(brandShops, (brandShop => brandShop.shopId === current));
  if (index > -1 && updatedShop) {
    dispatch(arraySplice('brandForm', 'brandShops', index, 1, {
      name: updatedShop.name,
      shopId: updatedShop.id,
      shopOrder: index,
      brandId: updatedShop.brandId,
    }));
  }
};
const onMembershipsEnabledChange = (e, checked) => async (dispatch) => {
  e.preventDefault();
  const confirmed = await confirmModal({
    type: 'danger',
    title: t('brand:form.overwrite_shops_confirmation_title'),
    message: t('brand:form.overwrite_shops_confirmation_message'),
  });

  if (confirmed) {
    dispatch(change('brandForm', 'settings.membershipsEnabled', checked));
  }
};
const onApiReaderEnabledChange = (e, checked) => async (dispatch) => {
  e.preventDefault();
  const confirmed = await confirmModal({
    type: 'danger',
    title: t('brand:form.overwrite_shops_confirmation_title'),
    message: t('brand:form.overwrite_shops_confirmation_message'),
  });

  if (confirmed) {
    dispatch(change('brandForm', 'apiReaderEnabled', checked));
  }
};


const mapDispatchToProps = {
  fetchBrand,
  updateBrand,
  deleteBrand,
  updateOrder,
  updateShopSelection,
  onMembershipsEnabledChange,
  onApiReaderEnabledChange,
  fetchBrandAndShopUsers,
  resetBrandAndShopUsers,
};

const EditBrandContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    props => !props.brand,
    renderNothing,
  ),
  withNotifications,
  withHandlers({
    onSave: props => brand => props.updateBrand(brand.id, brand).then(() => {
      if (
        brand.settings.staffManagementEnabled &&
        (
          props.brand.settings.primaryAccountOwner !== brand.settings.primaryAccountOwner ||
          props.brand.settings.staffManagementEnabled !== brand.settings.staffManagementEnabled
        )
      ) {
        props.addNotification({
          title: t('brand:edit.success_title'),
          level: 'success',
          message: t('brand:edit.staff_management_enabled_message'),
        });
      }

      props.addNotification({
        title: t('brand:edit.success_title'),
        level: 'success',
        message: t('brand:edit.update_success_message'),
      });
    }),
    onDelete: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('brand:form.delete_brand_confirmation_title'),
        message: t('brand:form.delete_brand_confirmation_message'),
      });

      if (confirmed) {
        props.deleteBrand(props.brand.id).then(() => {
          props.router.push('/admin/brands');
          props.addNotification({
            title: t('brand:edit.success_title'),
            level: 'success',
            message: t('brand:edit.delete_success_message'),
          });
        });
      }
    },
    onSortChange: props => sortedArray => props.updateOrder(sortedArray),
    onShopSelectionChange: props =>
      (e, next, prev) => props.updateShopSelection(next, prev, props.brandShops, props.shops),
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchBrand(this.props.params.id);
      this.props.fetchBrandAndShopUsers(this.props.params.id);
    },
    componentWillUnmount() {
      this.props.resetBrandAndShopUsers();
    },
  }),
  // there's an issue with initializing redux form after creating brand
  // so give it one more cycle to pick up a brand
  delayRender(0),
)(EditBrand);

export default EditBrandContainer;
